export const NAV_ITEM_LINKS = [
	{ navItemLinkNumber: '00', navItemLinkText: 'home' },
	{ navItemLinkNumber: '01', navItemLinkText: 'destination' },
	{ navItemLinkNumber: '02', navItemLinkText: 'crew' },
	{ navItemLinkNumber: '03', navItemLinkText: 'technology' },
];
